<!-- =========================================================================================
  File Name: List.vue
  Description: Partner List page
========================================================================================== -->

<template>

  <div id="page-devices-list">

    <vx-card ref="filterCard" title="Фильтры" class="devices-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Партнер</label>
          <v-select :options="partnersOptions()" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="partnersFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Активация</label>
          <v-select :options="activateOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="activateFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Подключение</label>
          <v-select :options="connectOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="connectFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Тип устройства</label>
          <v-select :options="typeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="typeFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Статус устройства</label>
          <v-select :options="stateOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="stateFilter" class="mb-4 md:mb-0" />
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div>
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ devicesData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : devicesData.length }} of {{ devicesData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(250)">
                <span>250</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>


        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="pl-4 pr-4 cursor-pointer flex-shrink">

          <div class="sm:mr-4 p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
            <span class="mr-2 leading-none">Действия</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-6 w-6" />
          </div>

          <vs-dropdown-menu>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg" @click="showPromptStatus()">
                <feather-icon icon="RefreshCwIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Изменить статус</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg" @click="gridApi.exportDataAsCsv()">
                <feather-icon icon="SaveIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Экспорт CSV</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="p-2 flex items-center text-lg text-danger" @click="confirmUnjoinDevices">
                <feather-icon icon="TrashIcon" svgClasses="h-6 w-6" class="mr-2" />
                <span>Отвязать устройства</span>
              </span>
            </vs-dropdown-item>

          </vs-dropdown-menu>
        </vs-dropdown>


        <div class="flex-grow">

          <vs-button type="border" color="primary" icon-pack="feather" icon="icon-refresh-cw" class="mr-4" @click="updateDevices">Обновить</vs-button>
        
        </div>


        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Поиск..." />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->


      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="devicesData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>


      <!-- PARTNER DEVICE CHANGE STATUS DIALOG -->
      <device-status :displayPrompt="displayPromptStatus" :devices="gridApi.getSelectedRows()" @hidePromptStatus="hidePromptStatus" v-if="displayPromptStatus"></device-status>
  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import modulePartner from '@/store/partner/modulePartner.js'
import moduleDevice from '@/store/device/moduleDevice.js'

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue"
import CellRendererEnable from "./cell-renderer/CellRendererEnable.vue"
import CellRendererPartner from "./cell-renderer/CellRendererPartner.vue"
import CellRendererActivate from "./cell-renderer/CellRendererActivate.vue"
import CellRendererConnect from "./cell-renderer/CellRendererConnect.vue"
import CellRendererType from "./cell-renderer/CellRendererType.vue"
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue"

import DeviceStatus            from "./DeviceStatus.vue"

export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererEnable,
    CellRendererPartner,
    CellRendererActivate,
    CellRendererConnect,
    CellRendererType,
    CellRendererStatus,

    DeviceStatus,
  },
  data() {
    return {
      displayPromptStatus        : false,

      enableFilter: { label: 'Все', value: 'all' },
      enableOptions: [],

      activateFilter: { label: 'Все', value: 'all' },
      activateOptions: [],

      connectFilter: { label: 'Все', value: 'all' },
      connectOptions: [],

      typeFilter: { label: 'Все', value: 'all' },
      typeOptions: [],

      partnersFilter: { label: 'Все', value: 'all' },

      stateFilter: { label: 'Все', value: 'all' },
      stateOptions: [],

      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        suppressMovable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'MN',
          field: 'did',
          width: 110,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: 'Серийный номер',
          field: 'ident',
          filter: true,
          width: 200,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Партнер',
          field: 'partid',
          width: 250,
          cellRendererFramework: 'CellRendererPartner'
        },
        {
          headerName: 'Активация',
          field: 'activate',
          width: 150,
          cellRendererFramework: 'CellRendererActivate'
        },
        {
          headerName: 'Подключение',
          field: 'online',
          width: 160,
          cellRendererFramework: 'CellRendererConnect'
        },
        {
          headerName: 'Тип устройства',
          field: 'type',
          width: 170,
          cellRendererFramework: 'CellRendererType'
        },
        {
          headerName: 'Статус',
          field: 'state',
          width: 250,
          cellRendererFramework: 'CellRendererStatus'
        },
      ],


      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererEnable,
        CellRendererPartner,
        CellRendererActivate,
        CellRendererConnect,
        CellRendererType,
        CellRendererStatus,
      }
    }
  },
  watch: {
    enableFilter(obj) {
      this.setColumnFilter("enable", obj.value)
    },
    activateFilter(obj) {
      this.setColumnFilter("activate", obj.value)
    },
    connectFilter(obj) {
      this.setColumnFilter("online", obj.value)
    },
    typeFilter(obj) {
      this.setColumnFilter("type", obj.value)
    },
    partnersFilter(obj) {
      this.setColumnFilter("partid", obj.value)
    },
    stateFilter(obj) {
      this.setColumnFilter("state", obj.value)
    },
  },
  computed: {
    partnersData() {
      return this.$store.state.partner.partners
    },
    devicesData() {
      return this.$store.state.partner.devices
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    showPromptStatus() {
      if (this.gridApi.getSelectedRows().length) {
        this.displayPromptStatus = true
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Изменение статуса`,
          text: `Необходимо выбрать из списка одно или несколько устройств, которые хотите изменить.`,
          acceptText: "Ок",
        })
      }
      
    },
    hidePromptStatus() {
      this.displayPromptStatus = false
      setTimeout(() => {
        // это место в реальной ситуации может некорректно работать
        this.updateDevices()
      }, 200)
      
    },
    partnersOptions() {
      let options = []
      this.partnersData.forEach(value => {
        options.push({ label: value.company, value: value.partid })
      })
      options.unshift({ label: 'Все', value: 'all' })
      return options
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if(val !== "all") {
        modelObj = { type: "equals", filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.enableFilter = this.activateFilter = this.connectFilter = this.typeFilter = this.stateFilter = { label: 'Все', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    updateDevices() {
      this.$store.dispatch("partner/fetchDevices")
      .then(() => {
        this.updateSearchQuery(this.searchQuery)
        // сбрасываем фильтры, иначе нужно найти способ обновить таблицу согласно выбранным фильтрам
        this.enableFilter = this.activateFilter = this.connectFilter = this.typeFilter = this.stateFilter = { label: 'Все', value: 'all' }
      })
      
    },
    confirmUnjoinDevices() {
      if (this.gridApi.getSelectedRows().length) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Отвязка устройств от партнера`,
          text: `Вы действительно хотите отвязать все выделенные устройства?`,
          accept: this.unjoinDevices,
          acceptText: "Отвязать",
          cancelText: "Отмена"
        })
      } else {
        this.$vs.dialog({
          color: 'primary',
          title: `Отвязка устройств от партнера`,
          text: `Выберите из списка устройства, которые хотите отвязать.`,
          acceptText: "Ок",
        })
      }
    },
    unjoinDevices() {
      this.$store.dispatch("partner/deleteDevices", this.gridApi.getSelectedRows())
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {


    if (!moduleDevice.isRegistered) {
      this.$store.registerModule('device', moduleDevice)
      moduleDevice.isRegistered = true
    }

    if (!modulePartner.isRegistered) {
      this.$store.registerModule('partner', modulePartner)
      modulePartner.isRegistered = true
    }

    this.$store.dispatch("partner/fetchDevices")
    .then(() => {
      let did = this.$route.params.deviceId
      if (did) {
        this.searchQuery = did
        this.updateSearchQuery(did)
      }
    })

    this.$store.dispatch("partner/fetchPartners")

    // this.enableOptions = Object.assign([], modulePartner.deviceEnableList)
    // this.enableOptions.unshift({ label: 'Все', value: 'all' })

    this.activateOptions = Object.assign([], moduleDevice.deviceActivateList)
    this.activateOptions.unshift({ label: 'Все', value: 'all' })

    this.connectOptions = Object.assign([], moduleDevice.deviceConnectList)
    this.connectOptions.unshift({ label: 'Все', value: 'all' })

    this.typeOptions = Object.assign([], moduleDevice.deviceTypeList)
    this.typeOptions.unshift({ label: 'Все', value: 'all' })

    this.stateOptions = Object.assign([], modulePartner.partnerDeviceStateList)
    this.stateOptions.unshift({ label: 'Все', value: 'all' })
  },
}

</script>

<style lang="scss">
#page-devices-list {
  .ag-theme-material .ag-cell {
    padding-right: 10px;
  }
  .vs__selected-options {
    max-width: 100%;
  }
  .vs__selected {
    white-space: nowrap;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 85%;
  }
  .devices-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
